import {Box, Button, Drawer, FormControl, Grid, InputLabel, MenuItem, Select, Typography} from "@material-ui/core";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {useDataProvider, useNotify} from "react-admin";
import {Store} from "../../store";
import {deleteOrderPlacementFLow, editOrderPlacementFlow, setAddOrderPlacementFlowDrawer} from "./actions";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles({
    container: {
        padding: '1rem 2rem',
        width: '40rem'
    },
    button: {
        marginTop: '2em'
    },
    title: {
        marginTop: '1em',
        marginBotton: '1em'
    },
    spacerLine: {
        paddingTop: '2em',
        borderBottom: '1px solid'
    }
});

const AddOrderPlacementFlowDrawer = (props) => {
    const classes = useStyles()
    const client = useSelector(state => state.user.client);
    const notify = useNotify();

    const [saveLoading, setSaveLoading] = useState(false);
    const flows = useSelector(state => state.orderPlacement);
    const [webshops, setWebShops] = useState([]);
    const [webshopData, setWebshopData,] = useState({
        webshopId: null,
    });
    const dataProvider = useDataProvider();

    const addFlow = async () => {
        const {data} = await (() => {
            try {
                return client.post(`/OrderPlacementFlow`, webshopData)
            } catch (e) {
                notify("Something went wrong.", "error")
            }
        })()
        return data;
    }

    const fetchWebshops = useCallback(async () => {
        const {data: webshops} = await dataProvider.getList(
            'webshop',
            {
                pagination: {page: 1, perPage: 300},
                sort: {field: 'Name', order: 'DESC'},
            }
        );
        setWebShops(webshops)
    }, [dataProvider]);

    useEffect(() => {
        fetchWebshops();
    }, [fetchWebshops]); // es

    return (
        <Drawer anchor={'right'} open={flows.addFlowDrawerOpen.drawerOpen} onClose={() => {
            Store.dispatch(setAddOrderPlacementFlowDrawer(false, flows.addFlowDrawerOpen.id))
            Store.dispatch(deleteOrderPlacementFLow(flows.addFlowDrawerOpen.id))
        }}>
            <Grid container spacing={1} className={classes.container}>
                <Grid item xs={12} md={12}>
                    <Typography className={classes.title} variant="h6" component="h2">New flow</Typography>

                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        setSaveLoading(true);
                        const data = await addFlow()
                        setSaveLoading(false);
                        Store.dispatch(editOrderPlacementFlow(flows.addFlowDrawerOpen.id, data))
                        Store.dispatch(setAddOrderPlacementFlowDrawer(false))

                    }}>
                        <FormControl fullWidth>
                            <Box class="supplier-select">
                                <InputLabel>Order source (webshop)</InputLabel>
                                <Select fullWidth value={webshopData.webshopId ?? ""}
                                        onChange={({target}) => {
                                            setWebshopData({
                                                ...webshopData,
                                                webshopId: target.value
                                            })
                                        }}>
                                    {
                                        webshops.map(i => <MenuItem value={i.id}>{i.name}</MenuItem>)
                                    }
                                </Select>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="outlinedPrimary"
                                    margin={0}
                                    className={classes.button}
                                >
                                    {saveLoading ?
                                        <CircularProgress size={"1.4em"} className={classes.white}/> : 'save'}
                                </Button>
                            </Box>
                        </FormControl>
                    </form>
                </Grid>
            </Grid>
        </Drawer>
    )
}

export default AddOrderPlacementFlowDrawer;